import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-shell flex-col items-center justify-center px-4 py-16 text-center md:px-8">
      <p className="font-label text-[11px] font-semibold uppercase tracking-[0.28em] text-accent-700">
        Error 404
      </p>
      <h1 className="mt-3 font-heading text-[32px] font-extrabold leading-tight tracking-tight text-foreground-950 md:text-[42px]">
        这个页面不在资料库里
      </h1>
      <p className="mt-3 max-w-md text-[13px] leading-relaxed text-foreground-600">
        链接可能已经失效，或者地址输入有误。你可以从首页重新开始，也可以直接搜索片名、导演或主演。
      </p>
      <p className="mt-3 rounded-md border border-background-200 bg-background-100 px-3 py-1.5 font-label text-[11px] text-foreground-500">
        {location.pathname}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-2.5">
        <Link
          to="/"
          className="flex cursor-pointer items-center gap-1.5 rounded-md bg-primary-800 px-4 py-2.5 text-[12px] font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-home-4-line text-sm" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-[12px] text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-search-line text-sm" />
          站内搜索
        </Link>
        <Link
          to="/specials"
          className="flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-[12px] text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          浏览专题
        </Link>
      </div>
    </div>
  );
}